import React from 'react';

interface AlertProps {
  title: string;
  message: string;
  type: 'error' | 'warning' | 'info' | 'success';
  onRetry?: () => void;
  onClose?: () => void;
}

const typeClasses = {
  error: {
    bg: 'bg-red-100',
    border: 'border-red-500',
    text: 'text-red-700',
    button: 'bg-red-200 hover:bg-red-300'
  },
  warning: {
    bg: 'bg-yellow-100',
    border: 'border-yellow-500',
    text: 'text-yellow-700',
    button: 'bg-yellow-200 hover:bg-yellow-300'
  },
  info: {
    bg: 'bg-pink-100',
    border: 'border-primary',
    text: 'text-pink-800',
    button: 'bg-pink-200 hover:bg-pink-300'
  },
  success: {
    bg: 'bg-green-100',
    border: 'border-green-500',
    text: 'text-green-700',
    button: 'bg-green-200 hover:bg-green-300'
  }
};

const Alert: React.FC<AlertProps> = ({ title, message, type, onRetry, onClose }) => {
  const classes = typeClasses[type];
  return (
    <div className={`${classes.bg} border-l-4 ${classes.border} ${classes.text} p-4 rounded-md my-8`} role="alert">
      <div className="flex justify-between items-start">
        <div className="flex-1">
          <p className="font-bold">{title}</p>
          <p>{message}</p>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="ml-4 text-gray-500 hover:text-gray-700"
            aria-label="Schließen"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>
      {onRetry && (
        <div className="mt-4">
          <button
            onClick={onRetry}
            className={`font-semibold px-4 py-2 rounded-md ${classes.button} transition-colors text-sm`}
            aria-label="Laden der Agenda erneut versuchen"
          >
            Erneut versuchen
          </button>
        </div>
      )}
    </div>
  );
};

export default Alert;